export default "__VITE_ASSET__55d1aa41__"